import setup from "./setup";
var track = function track(event, args, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$renewSession = _ref.renewSession,
    renewSession = _ref$renewSession === void 0 ? false : _ref$renewSession,
    _ref$includeContext = _ref.includeContext,
    includeContext = _ref$includeContext === void 0 ? true : _ref$includeContext;
  return setup().then(function (_) {
    window.tagular("beam", Object.assign({
      "@type": event
    }, args), renewSession, includeContext);
    console.log("%c @analytics/make - track", "color: purple", Object.assign({
      event: event
    }, args));
  });
};
export default {
  track: track
};